export default "__VITE_ASSET__Dqc7hXvJ__"